import React, { memo } from "react";
import PropTypes from "prop-types";
const Table = memo(({ title, preferred, icon, colorClass, children, iconHoverText, AdditionalElementOnTable }) => {
	return (
		<table className="table">
			<thead>
				<tr>
					<th colSpan={2}>
						<span>{title}</span>
						{(preferred || icon || colorClass) && (
							<span
								className={` 
									${icon || `glyphicon glyphicon-star`} 
									${colorClass || `preferred-icon`}`}
								aria-hidden="true"
								title={iconHoverText}
							/>
						)}
						{AdditionalElementOnTable}
					</th>
				</tr>
			</thead>
			<tbody>{children}</tbody>
		</table>
	);
});
Table.displayName = `Table`;
Table.propTypes = {
	title: PropTypes.string.isRequired,
	rows: PropTypes.object,
	preferred: PropTypes.bool,
	icon: PropTypes.string,
	colorClass: PropTypes.string,
	children: PropTypes.object,
	iconHoverText: PropTypes.string,
	AdditionalElementOnTable: PropTypes.element
};

export default Table;
